import {connect} from "react-redux";
import ExternalMoMView from "./View";
import {bindActionCreators} from "redux";
import {momByIdRequest} from "../../../../service/Valet/action";

const mapStateToProps = (state) => ({
    momByIdResponse:state.Valet.momByIdResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            momByIdRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ExternalMoMView);
